import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import CountrySelectField from 'components/forms/countrySelectField/CountrySelectField';
import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import SelectField from 'components/forms/selectField/SelectField';
import { PreArrivalFormFields } from '../../PreArrivalFormTab.types';
import {
  PrimaryGuestInfoContainer,
  PreviewRow,
} from '../PreviewPreArrivalForm.styles';
import useShouldShowField from '../useShouldShowField';
import GovernmentIdFileField from '../fields/GovernmentIdFileField';

const PrimaryGuestInformationSection = () => {
  const { t } = useTranslation();
  const { shouldShowField } = useShouldShowField();

  return (
    <PrimaryGuestInfoContainer data-testid="preview-primary-guest-information-section">
      <h2>
        {t('pageAutomations.preArrivalForm.preview.primaryGuestInfo.header')}
      </h2>

      <PreviewRow columns={5}>
        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_FIRST_NAME,
          <TextField
            value={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.firstNameValue',
            )}
            colSmInput={12}
            name="preview.firstName"
            disabled
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.firstName',
            )}
          />,
        )}

        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_LAST_NAME,
          <TextField
            value={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.lastNameValue',
            )}
            colSmInput={12}
            name="preview.lastName"
            disabled
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.lastName',
            )}
          />,
        )}

        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_EMAIL,
          <TextField
            colSmInput={12}
            name="preview.email"
            disabled
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.email',
            )}
          />,
        )}

        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_PHONE_NUMBER,
          <TextField
            colSmInput={12}
            name="preview.phoneNumber"
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.phoneNumber',
            )}
          />,
        )}

        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_AGE,
          <TextField
            colSmInput={12}
            name="preview.age"
            type="number"
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.age',
            )}
          />,
        )}
      </PreviewRow>

      <PreviewRow>
        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_GOVERNMENT_ID,
          <GovernmentIdFileField
            name="preview.governmentIdFile"
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.governmentIdFile',
            )}
          />,
        )}
        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_GOVERNMENT_ID,
          <CountrySelectField
            rightTooltip={t(
              'pageAutomations.preArrivalForm.preview.governmentId.countryTooltip',
            )}
            colSmInput={12}
            name="preview.governmentIdCountry"
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.governmentIdCountry',
            )}
          />,
        )}
        {shouldShowField(
          PreArrivalFormFields.PRIMARY_GUEST_GOVERNMENT_ID,
          <TextField
            rightTooltip={t(
              'pageAutomations.preArrivalForm.preview.governmentId.numberTooltip',
            )}
            colSmInput={12}
            name="preview.governmentIdNumber"
            labelOnTop
            label={t(
              'pageAutomations.preArrivalForm.preview.primaryGuestInfo.governmentIdNumber',
            )}
          />,
        )}
      </PreviewRow>

      {shouldShowField(
        PreArrivalFormFields.OTHER_HAS_VISITORS,
        <RadioGroupField
          colSmInput={12}
          name="preview.willAnyoneBeVisiting"
          containerClassName="horizontal-radio-group"
          labelOnTop
          label={t(
            'pageAutomations.preArrivalForm.preview.primaryGuestInfo.willAnyoneBeVisiting',
          )}
          options={[
            {
              label: t('common.yes'),
              value: 'YES',
            },
            {
              label: t('common.no'),
              value: 'NO',
            },
          ]}
        />,
      )}

      {shouldShowField(
        PreArrivalFormFields.OTHER_HOSTING_EVENTS,
        <RadioGroupField
          colSmInput={12}
          name="preview.willYouBeHostingGatherings"
          containerClassName="horizontal-radio-group"
          labelOnTop
          label={t(
            'pageAutomations.preArrivalForm.preview.primaryGuestInfo.willYouBeHostingGatherings',
          )}
          options={[
            {
              label: t('common.yes'),
              value: 'YES',
            },
            {
              label: t('common.no'),
              value: 'NO',
            },
          ]}
        />,
      )}

      {shouldShowField(
        PreArrivalFormFields.PRIMARY_GUEST_NUMBER_OF_GUESTS,
        <SelectField
          colSmInput={4}
          name="preview.howManyGuests"
          labelOnTop
          label={t(
            'pageAutomations.preArrivalForm.preview.primaryGuestInfo.howManyGuests',
          )}
          options={Array.from({ length: 99 }, (_, i) => ({
            label: (i + 1).toString(),
            value: (i + 1).toString(),
          }))}
        />,
      )}
    </PrimaryGuestInfoContainer>
  );
};

export default PrimaryGuestInformationSection;
